import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "new-to-uxp-where-to-go-next"
    }}>{`New to UXP? Where to Go Next`}</h1>
    <p>{`The answer to that question depends on what you currently know.`}</p>
    <ul>
      <li parentName="ul">{`If you've created UXP plugins for other Adobe applications (e.g., XD) and just need to know what's different for Photoshop, `}<a parentName="li" {...{
          "href": "uxp_for_xd_devs/"
        }}>{`start here`}</a>{`.`}</li>
      <li parentName="ul">{`If you're unfamiliar with UXP, but have built extensions for Photoshop using the CEP (Common Extensibility Platform), `}<a parentName="li" {...{
          "href": "uxp_for_cep_devs/"
        }}>{`start here`}</a>{`.`}</li>
      <li parentName="ul">{`If you've never used UXP nor CEP, but `}<em parentName="li">{`have`}</em>{` written scripts using Adobe ExtendScript, `}<a parentName="li" {...{
          "href": "uxp_for_extendscript_devs/"
        }}>{`start here`}</a>{`.`}</li>
      <li parentName="ul">{`If you've never scripted Photoshop using the above technologies, but you know some HTML, CSS, and JavaScript, `}<a parentName="li" {...{
          "href": "uxp_for_web_devs/"
        }}>{`start here`}</a>{`.`}</li>
      <li parentName="ul">{`If you are a total newbie at all of this, good for you! `}<a parentName="li" {...{
          "href": "uxp_for_newbies/"
        }}>{`Start here to begin your awesome journey`}</a>{`.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      